import React from 'react';
import { Insight } from '../../services/insightsService';
import { getTypeMeta, getPayloadMetrics, timeAgo } from './insightPresentation';

interface InsightCardProps {
  insight: Insight;
}

const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  const typeMeta = getTypeMeta(insight.type);
  const metrics = getPayloadMetrics(insight);

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e2e8f0',
        borderLeft: `4px solid ${typeMeta.color}`,
        padding: 16,
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      {/* Header: type + time */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 16 }}>{typeMeta.emoji}</span>
        <span style={{ fontWeight: 700, color: '#1f2937', fontSize: 14 }}>{typeMeta.label}</span>
        <span style={{ color: '#94a3b8', fontSize: 13 }}>· {timeAgo(insight.created_at)}</span>
      </div>

      {/* Summary sentence (display text) */}
      <div style={{ color: '#1f2937', fontSize: 15, lineHeight: 1.45, marginBottom: metrics.length || insight.disclaimer ? 12 : 0 }}>
        {insight.summary}
      </div>

      {/* Key metrics from payload */}
      {metrics.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: insight.disclaimer ? 12 : 0 }}>
          {metrics.map((m) => (
            <div
              key={m.label}
              style={{
                background: '#f6f8fa',
                borderRadius: 8,
                padding: '6px 10px',
                fontSize: 13,
              }}
            >
              <span style={{ color: '#64748b' }}>{m.label}: </span>
              <span style={{ color: '#1f2937', fontWeight: 600 }}>{m.value}</span>
            </div>
          ))}
        </div>
      )}

      {/* Disclaimer (non-null only for cross_signal) */}
      {insight.disclaimer && (
        <div style={{ background: '#fffbeb', color: '#92400e', fontSize: 12, padding: '8px 10px', borderRadius: 8 }}>
          {insight.disclaimer}
        </div>
      )}
    </div>
  );
};

export default InsightCard;
